import PartOfSpeech from './PartOfSpeech';

export default PartOfSpeech;
